import { dataArrowToTopSoild } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowToTopSoild = /*#__PURE__*/createIcon(dataArrowToTopSoild)
/** @deprecated */
export default IconArrowToTopSoild
